import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import common from 'styles/common';
import { media } from 'styles/breakpoints';

const Container = styled.div`
  width: 100%;
  background-color: #d5343d;
  color: #fff;
  box-shadow: ${common.boxShadow};
  font-family: 'Lato', sans-serif;

  ${media.small`
    width: 400px;
    margin: 0 auto;
  `} ${media.medium`
    width: 500px;
  `};
`;

const Title = styled.h2`
  text-align: center;
  margin: 0;
  padding: 40px 20px 0;
  font-size: 36px;
`;

const Text = styled.p`
  text-align: justify;
  font-size: 20px;
  line-height: 28px;
  margin: 0;
  padding: 40px;
`;

export default function FactCheck({ text }) {
  if (!text) return null;

  return (
    <Container>
      <Title>Fact Check</Title>
      <Text>{text}</Text>
    </Container>
  );
}

FactCheck.propTypes = {
  text: PropTypes.string
};

FactCheck.defaultProps = {
  text: null
};



// WEBPACK FOOTER //
// ./src/components/FactCheck/FactCheck.js